import { render } from "./OrdersViewUser_Component.vue?vue&type=template&id=3f294163&scoped=true"
import script from "./OrdersViewUser_Component.vue?vue&type=script&lang=js"
export * from "./OrdersViewUser_Component.vue?vue&type=script&lang=js"

import "./OrdersViewUser_Component.vue?vue&type=style&index=0&id=3f294163&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f294163"]])

export default __exports__